module.exports = __webpack_public_path__ + "static/media/GeraltofRivia.845528de.png";